import JadwalService from "@/services/jadwal";
import ProductsService from "@/services/products";
import { forEach, isEmpty } from "lodash";

export default {
  namespaced: true,
  state: {
    events: [],
    productJasa: [],
    allProductJasa: null,
  },
  mutations: {
    SET_EVENTS(state, events) {
      state.events = events;
    },
    SET_PRODUCT_JASA(state, productJasa) {
      state.productJasa = productJasa;
    },
    SET_ALL_INFO_PRODUCT_JASA(state, allProductJasa) {
      state.allProductJasa = allProductJasa;
    },
  },
  actions: {
    async getEvents({ commit, state, getters, dispatch }, month) {
      try {
        let response = await JadwalService.getJadwal(month);
        let jadwal = [];
        forEach(response.data.attributes, (schedule) => {
		let objectJadwal = {
			id: schedule.id,
			start: schedule.start,
			end: schedule.finish,
			color: "green",
		};
          if (schedule && schedule.item) {
            objectJadwal = {
			  ...objectJadwal,
              name: schedule.item.item_name,
              details:
                schedule.item.item_name +
                " sudah di pesan oleh " +
                schedule.submissions[0].customer.name,
            };

            jadwal.push(objectJadwal);
          }
        });

        commit("SET_EVENTS", jadwal);
      } catch (e) {
        console.log(e);
      }
    },
    async getProductJasa(
      { commit, state, getters, dispatch },
      product_category_id
    ) {
      try {
        // let response = await JadwalService.getProductJasa()
        let opts = {
          interfaces: ["pos"],
          type: ["MANAGED_TIME"],
          product_category_id: product_category_id,
        };

        let response = await ProductsService.getProducts(opts);

        let jasa = [];
        forEach(response.data.attributes, (productJasa) => {
          const objectJasa = {
            text: productJasa.name,
            value: productJasa.id,
          };

          jasa.push(objectJasa);
        });

        commit("SET_PRODUCT_JASA", jasa);
        commit("SET_ALL_INFO_PRODUCT_JASA", response.data.attributes);
      } catch (e) {
        console.log(e);
      }
    },
    async getProductJasaEdit({ commit, state, getters, dispatch }, item) {
      try {
        const payload = {
          id: 6,
          harga: Number(item.harga_jual),
        };
        let response = await JadwalService.getProductJasaEdit(payload);
        // return response
        let jasa = [];
        forEach(response.data.attributes, (productJasa) => {
          const objectJasa = {
            text: productJasa.name,
            value: productJasa.id,
          };

          jasa.push(objectJasa);
        });

        commit("SET_PRODUCT_JASA", jasa);
        commit("SET_ALL_INFO_PRODUCT_JASA", response.data.attributes);
      } catch (e) {
        console.log(e);
      }
    },
    async cekJadwal({ commit, state, getters, dispatch }, payload) {
      try {
        let response = await JadwalService.cekJadwal(payload);
        return response;
      } catch (e) {
        console.log(e);
      }
    },
    async createJadwal({ commit, state, getters, dispatch }, payload) {
      try {
        let response = await JadwalService.createJadwal(payload);
        return response;
      } catch (e) {
        console.log(e);
      }
    },
    async updateJadwal({ commit, state, getters, dispatch }, payload) {
      try {
        let response = await JadwalService.updateJadwal(payload.id, {
          ...payload,
        });
        return response;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
